import PropTypes from 'prop-types';
const commonPropTypes = {
    intl: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired,
};
const linkPropTypes = PropTypes.shape({
    key: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    flag: PropTypes.oneOf(['PROMO']),
});
export const LinkItemPropTypes = {
    ...commonPropTypes,
    link: linkPropTypes,
};
export const SettingsDropdownListPropTypes = {
    ...commonPropTypes,
    helpLink: PropTypes.string,
    links: PropTypes.arrayOf(linkPropTypes).isRequired,
};
//# sourceMappingURL=prop-types.js.map